import { makeStyles } from '@material-ui/core/styles';
import { reskinStyles } from 'core/components/theme/theme-variant';

const useStyles = makeStyles((theme) => ({
  priceCard: {
    ...reskinStyles(theme, theme.cardStyles.highlight)
  },
  subSection: {
    borderBottom: `1px solid ${theme.onCardDivider.beige_25_op_30}`,
    padding: theme.spacing(6, 8),
    '&:last-of-type': {
      borderBottom: 'none'
    }
  },
  loadingWheel: {
    boxShadow: 'none'
  },
  container: {
    position: 'relative',
    minHeight: 100,
    display: 'flex',
    flexDirection: 'column',
    overflow: 'visible',
    backgroundColor: theme.colors.card_background_secondary,
    ...reskinStyles(theme, theme.cardStyles.body)
  },
  cardHeader: {
    display: 'flex',
    flexGrow: 0,
    justifyContent: 'space-between',
    alignItems: 'center',
    height: 100,
    backgroundColor: theme.colorPalette.white_op_10,
    padding: theme.spacing(8, 7)
  },
  iconFold: {
    display: 'block',
    height: 32,
    width: 32,
    transition: 'transform var(--motion-duration-close, 0ms) var(--motion-ease-out, ease-out)'
  },
  icon: {
    composes: '$iconFold',
    transform: 'rotate(180deg)'
  },
  connectedCard: {
    display: 'flex',
    flexGrow: 0,
    justifyContent: 'flex-start',
    alignItems: 'center',
    flexDirection: 'row',
    gap: theme.spacing(16),
    padding: theme.spacing(8)
  },
  module: {
    position: 'relative',
    display: 'flex',
    flexDirection: 'column',
    overflow: 'visible',
    justifyContent: 'center',
    alignItems: 'center',
    backgroundColor: theme.colors.card_background_secondary,
    ...reskinStyles(theme, theme.cardStyles.body)
  },
  moduleCollapsed: {
    paddingTop: theme.spacing(8)
  },
  priceIncrease: {
    display: 'flex',
    flexDirection: 'row',
    justifyContent: 'space-between',
    alignItems: 'center',
    width: 656,
    height: 56,
    marginBottom: theme.spacing(8),
    padding: theme.spacing(4),
    backgroundColor: theme.colorPalette.green_100,
    fontSize: 14,
    fontWeight: 400,
    color: theme.onCard.white,
    borderRadius: theme.sizes.innerCorners,
    ...reskinStyles(theme, { backgroundColor: theme.colorPalette.beige_50, borderRadius: theme.sizes.innerCorners })
  },
  iconSection: {
    display: 'flex',
    flexDirection: 'row',
    height: 20,
    alignItems: 'center'
  },
  notificationIcon: {
    height: 16,
    width: 16,
    marginRight: theme.spacing(2)
  },
  compareSection: {
    display: 'flex',
    flexDirection: 'row',
    height: 24,
    alignItems: 'center',
    color: theme.colors.action_text,
    fontSize: 14,
    borderRadius: theme.spacing(2)
  },
  compareLabel: {
    padding: theme.spacing(2),
    display: 'flex',
    flexDirection: 'row',
    height: 24,
    alignItems: 'center'
  },
  compareIcon: {
    height: 24,
    width: 24,
    marginRight: theme.spacing(2)
  }
}));

export default useStyles;
